// HomePage.js (carousel snippet)

import React from 'react';
import { Carousel, Card } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';

const publicImages = Array.from({ length: 6 }, (_, i) => `/S24_P${i + 1}.JPG`);

const PrevArrow = ({ onClick }) => (
  <LeftOutlined
    onClick={onClick}
    style={{
      fontSize: 24,
      color: '#1890ff',
      position: 'absolute',
      top: '50%',
      left: 8,
      zIndex: 1,
      cursor: 'pointer',
      transform: 'translateY(-50%)',
    }}
  />
);

const NextArrow = ({ onClick }) => (
  <RightOutlined
    onClick={onClick}
    style={{
      fontSize: 24,
      color: '#1890ff',
      position: 'absolute',
      top: '50%',
      right: 8,
      zIndex: 1,
      cursor: 'pointer',
      transform: 'translateY(-50%)',
    }}
  />
);

export default function InternshipGalleryCarousel() {
  return (
    <Card style={{ marginBottom: 40, position: 'relative', overflow: 'hidden' }}>
      <Carousel
        autoplay
        infinite
        pauseOnHover
        dots={false}
        slidesToShow={1}
        adaptiveHeight
        prevArrow={<PrevArrow />}
        nextArrow={<NextArrow />}
      >
        {publicImages.map((src, idx) => (
          <div key={idx} style={{ display: 'flex', justifyContent: 'center' }}>
            <img
              src={src}
              alt={`Internship slide ${idx + 1}`}
              loading="lazy"
              style={{
                width: '100%',
                maxHeight: 600,
                objectFit: 'cover',
                borderRadius: 8,
                boxShadow: '0 6px 18px rgba(0,0,0,0.15)',
                transition: 'transform 0.3s ease',
              }}
              onMouseEnter={e => (e.currentTarget.style.transform = 'scale(1.02)')}
              onMouseLeave={e => (e.currentTarget.style.transform = 'scale(1)')}
            />
          </div>
        ))}
      </Carousel>
    </Card>
  );
}
